export enum ProfileField {
  Config = 'config',
  Basics = 'basics',
  Work = 'work',
  Education = 'education',
  Projects = 'projects',
  Awards = 'awards',
  Publications = 'publications',
  Gallery = 'gallery',
  Skills = 'skills',
  Languages = 'languages',
  Interests = 'interests',
  References = 'references',
  Custom = 'custom',
  SlugMap = 'slugMap',
}

export enum PublicationTypes {
  Article = 'article',
  Book = 'book',
  Thesis = 'thesis',
  TechReport = 'techreport',
  InCollection = 'incollection',
  Misc = 'misc',
  UnPublished = 'unpublished',
}

export enum ThesisTypes {
  PhD = 'phd',
  Masters = 'masters',
  Bachelors = 'bachelors',
}

export enum SocialProfileTypes {
  GoogleScholar = 'googlescholar',
  GitHub = 'github',
  GitLab = 'gitlab',
  LinkedIn = 'linkedin',
  YouTube = 'youtube',
  Vimeo = 'vimeo',
  Twitter = 'twitter',
  Facebook = 'facebook',
  Twitch = 'twitch',
}